import React from "react";
import styles from "./SolutionsHeroBanner.module.scss";

const SolutionsHeroBanner = ({ title }) => {
  return (
    <section className={styles.heroBanner}>
      <div className={styles.overlay}>
        <h1 className={styles.title}>{title}</h1>
      </div>
    </section>
  );
};

export default SolutionsHeroBanner;
